module.exports = __webpack_public_path__ + "media/img/pages/companies/thyssenkrupp-ff37e613e6e29a63e7a87bb765abca23.png";